/* eslint-disable no-unused-vars */
import React, { ComponentType } from 'react';
import { Route, Redirect } from 'react-router-dom';
import { signinPath, onboardingPath, dashboardPath } from '../../../routes';

interface RouteProps {
  exact?: boolean,
  path: string,
  component: ComponentType<any>,
  isAuthenticated: boolean,
  isOnboarded: boolean
}

const AuthenticatedRoute = ({
  exact, path, component, isAuthenticated, isOnboarded,
}:RouteProps) => {
  if (!isAuthenticated) {
    /**
     * This is a little hack for the gapi script to reset
     * as normal singOut is not working for our current implementation
     */
    window.location.replace(`${window.location.origin}/signin`);
  }

  // TODO Matt: Do we need this anymore?
  /*
  if (isOnboarded && path.includes(onboardingPath)) {
    return (
      <Route exact={exact} path={path}>
        <Redirect to={dashboardPath} />
      </Route>
    );
  }
  */

  if (!isOnboarded && !path.includes(onboardingPath)) {
    return (
      <Route exact={exact} path={path}>
        <Redirect to={onboardingPath} />
      </Route>
    );
  }

  return <Route exact={exact} path={path} component={component} />;
};

AuthenticatedRoute.defaultProps = {
  exact: false,
};

export default AuthenticatedRoute;
